module.exports = __webpack_public_path__ + "static/media/wuyi_bg1.b153ee41.jpg";